import isISO8601 from 'validator/lib/isISO8601';
import { z } from 'zod';

import objectPassthrough from '../../objectPassthrough';
import { ISODateString } from '../../types';

export interface ImportInfo {
  // An id for the import process, identifying all logins from the same import
  // format: keepass-2026-01-01-fksjl
  readonly importId: string;
  readonly importTime: ISODateString;
}

export const ImportInfo = objectPassthrough({
  importId: z.string(),
  importTime: z.string().refine((str) => isISO8601(str)),
});
